var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.studentSieId)?_c('div',[_c('page-header',{attrs:{"has-return":"","page":{
      icon: 'fas fa-calendar-day',
      title: 'Registro de Visitas',
      routes: ['Inicio', 'Registro de Visitas'],
    }}}),_c('visit-log-history',{attrs:{"student-sie-id":Number(_vm.studentSieId)}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }